import { ListYellowBulletIcon } from "@/src/Asset";
import React, { useState } from "react";
// import Loader from "../loader/Loader";
// import UpdateDateArticle from "../updatedDateArticle/updatedDateArticle";
import PageData from "../pageData/pageData";
import Accordian from "../accordian/accordian";

interface TabData {
  __component: string;
  heading?: string;
}

// PageDetailsTab Props Interface
interface PageDetailsTabProps {
  tabsData: TabData[];
  page: any;
  currentTab: string;
  loading?: boolean;
  sideBar?: boolean;
}

const PageDetailsTab = ({
  tabsData,
  page,
  currentTab,
  loading,
  sideBar = true,
}: PageDetailsTabProps) => {
  const showTableOfContent = true;
  const [openAccordionId, setOpenAccordionId] = useState<string | null>(null);
  // const sectionRefs = useRef<(HTMLElement | null)[]>([]);

  const tableOfContentId = `${currentTab}-table-of-content`;
  const latestUpdateId = `${currentTab}-latest-update`;

  const handleAccordionToggle = (id: string) => {
    setOpenAccordionId((prev) => (prev === id ? null : id));
  };

  // const scrollToSection = (index: number, offset: number) => {
  //   if (typeof window === "undefined" || typeof document === "undefined")
  //     return;

  //   const section = document.getElementById(`section-${index}`);
  //   if (section) {
  //     const topPos = section.offsetTop;
  //     const adjustedOffset = window.innerWidth <= 768 ? 165 : offset;

  //     window.scrollTo({
  //       top: topPos - adjustedOffset + 40,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  // if (loading) {
  //   return (
  //     <div className="flex justify-center mt-4">
  //       <Loader />
  //     </div>
  //   );
  // }
  const sortedTabsData = tabsData?.filter(
    (data: any) =>
      data.__component !== "common.latest-update" &&
      data.__component !== "course.latest-update" &&
      data.__component !== "special.latest-update" &&
      data.__component !== "exam.latest-update" &&
      data.__component !== "common.seo" &&
      data.__component !== "course.seo" &&
      data.__component !== "special.seo" &&
      data.__component !== "exam.seo"
  );
  const latestUpdateData = tabsData?.filter(
    (data: any) =>
      data.__component === "common.latest-update" ||
      data.__component === "course.latest-update" ||
      data.__component === "special.latest-update" ||
      data.__component === "exam.latest-update"
  );

  return (
    <section className="tableContentSection p-2">
      {/* {sideBar === true && (
        <div className="flex flex-col md:mb-2 mt-1">
          <UpdateDateArticle
            dateTime={page?.updatedAt?.slice(0, 10)}
            updatedByUser={page?.updated_by_user}
          />
        </div>
      )} */}
      <div className="flex gap-x-4 max-w-screen-xl mx-auto">
        <div
          className="flex-1 flex flex-col gap-x-4 space-y-3 md:space-y-4 md:w-full w-[100vw] mx-auto"
          key={page?.id}
        >
          {latestUpdateData?.[0] && (
            <div className="mt-2 md:mt-0">
              <PageData
                tabData={latestUpdateData?.[0]}
                pageData={page}
                key="latest-update"
                id={latestUpdateId}
              />
            </div>
          )}
          {showTableOfContent ? (
            <Accordian
              title="Table of Content"
              titlePrimary
              opened={openAccordionId === tableOfContentId}
              id={tableOfContentId}
              onToggle={() => handleAccordionToggle(tableOfContentId)}
            >
              <div className="bg-primary-extra-light p-2 md:p-5 flex flex-col gap-x-4">
                {sortedTabsData?.map((table: any, index: any) => {
                  let label;
                  switch (table?.__component) {
                    case "common.recommended-colleges":
                    case "course.recommended-colleges":
                    case "special.recommended-colleges":
                    case "exam.recommended-colleges":
                      label = "Recommended Colleges";
                      break;

                    case "common.recommended-courses":
                    case "course.recommended-courses":
                    case "special.recommended-courses":
                    case "exam.recommended-courses":
                      label = "Recommended Courses";
                      break;

                    case "common.recommended-exams":
                    case "course.recommended-exams":
                    case "special.recommended-exams":
                    case "exam.recommended-exams":
                      label = "Recommended Exams";
                      break;

                    // case "common.recommended-careers":
                    // case "course.recommended-careers":
                    //   label = "Recommended Careers";
                    //   break;

                    case "common.recommended-scholar":
                    case "course.recommended-scholar":
                    case "special.recommended-scholar":
                    case "exam.recommended-scholar":
                      label = "Recommended Scholarships";
                      break;

                    case "common.recommended-countries":
                    case "course.recommended-countries":
                    case "special.recommended-countries":
                    case "exam.recommended-countries":
                      label = "Recommended Countries";
                      break;

                    default:
                      label = table?.heading;
                  }
                  return (
                    <div key={`${table?.id}-${index}`}>
                      <div className="flex gap-4 py-0.5 text-xs md:text-base font-poppins">
                        <ListYellowBulletIcon />
                        <div className="font-medium text-primary cursor-pointer">
                          <button
                          // onClick={() => scrollToSection(index, 200)}
                          >
                            {label}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Accordian>
          ) : (
            <></>
          )}

          {sortedTabsData?.map((tabData: any, index: number) => {
            return (
              <section
                id={`section-${index}`}
                key={`${tabData?.id}-${index}`}
                // ref={(el) => {
                //   sectionRefs.current[index] = el;
                // }}
                className="my-8 md:w-full w-[100vw] overflow-x-scroll mx-auto"
              >
                <PageData tabData={tabData} pageData={page} id={tabData?.id} />
              </section>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PageDetailsTab;
